<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show" class="black--text">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
    <v-container class="ma-0 pa-0" data-html2canvas-ignore>
      <v-row no-gutters class="ma-0 pa-0">
        <v-col class="ma-0 pa-0 text-left ml-3">
          <span
            :key="hover_text"
            class="trade-blue-text font-weight-bold hs8_code mt-0 pt-0"
            >{{ hover_text }}</span
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'abs_stacked_chart',
    components: {
      VuePlotly,
    },
    props: ['graph_data', 'hover_text'],
    computed: {
      ...mapGetters([
        'get_dsm_result',
        'historyPlotDataTotal',
        'getDsmAppState',
        'app_data',
        'single_product',
        'home_market_code',
      ]),

      plotData: function () {
        //

        return this.graph_data['data'].map((v, i) => {
          return {
            ...v,
            fillcolor: config.plot_top6_colors[i],
            y: v['y'].map(q => q / this.app_data.value_mulitplier['divider'] / 1000),
            showlegend: true,
          };
        });
      },
      show: function () {
        return true;
      },
      layout: function () {
        return {
          title: {
            text:
              this.graph_data['main_title'] + '<br>' + this.graph_data['secondary_title'],
            font: {
              size: 10,
              color: 'black',
            },
            yref: 'container',
            x: 0.5,
            y: 0.9,
            yanchor: 'bottom',
            pad: {
              b: 10,
            },
          },

          height: '300',

          autosize: true,
          margin: {
            l: 30,
            r: 0,
            b: 70,
            t: 90,
            pad: 4,
          },

          // ...('x_names' in this.plotData[0]
          //   ? {
          //       shapes: [
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 3,
          //           x1: 3,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 7,
          //           x1: 7,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 11,
          //           x1: 11,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 15,
          //           x1: 15,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 19,
          //           x1: 19,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 23,
          //           x1: 23,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 27,
          //           x1: 27,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //       ],
          //     }
          //   : {
          //       shapes: [
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 2016,
          //           x1: 2016,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 2017,
          //           x1: 2017,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 2018,
          //           x1: 2018,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 2019,
          //           x1: 2019,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //         {
          //           type: 'line',
          //           xref: 'x',
          //           x0: 2020,
          //           x1: 2020,
          //           yref: 'paper',
          //           y0: -0.02,
          //           y1: 1,
          //           line: {
          //             color: config.plot_red,
          //             width: 1,
          //             dash: 'dot',
          //           },
          //         },
          //       ],
          //     }),
          xaxis: {
            tickangle: 90,
            automargin: true,
            tickfont: {
              size: 9,
            },

            ...('x_names' in this.plotData[0]
              ? {
                  tickmode: 'array',
                  tickvals: this.plotData[0]['x_names'].map((v, i) => i),
                  ticktext: this.plotData[0]['x_names'],
                }
              : {
                  tickmode: 'linear',
                }),
          },
          yaxis: {
            title: '',
            rangemode: 'tozero',

            tickfont: {
              size: 10,
            },
          },
          legend: {
            font: {size: 9},
            automargin: true,
          },
          annotations: [
            {
              x: '0',
              y: '1.16',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'left',
              yanchor: 'top',
              text: this.graph_data['secondary_title'].includes('volume')
                ? this.graph_data['units']
                : this.app_data.value_mulitplier['prefix'] +
                  ' ' +
                  this.graph_data['currency'],
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: -0.02,
              y: 'x_names' in this.plotData[0] ? -0.47 : -0.37,
              xanchor: 'left',
              yanchor: 'bottom',
              text: this.graph_data['source'],
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8.5,
                color: 'rgb(150,150,150)',
              },
            },
          ],
        };
      },
    },

    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>

<style scoped>
  .hs8_code {
    display: block;
    max-height: 60px;
    min-height: 60px;
    height: 60px;
    padding: 10px;
    font-size: 11px;
    line-height: normal;
    max-width: 100%;
    font-weight: lighter;
  }
</style>
